import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import AmznController from './AmznController'

// import { objectViewStart, objectViewStop } from './../amzn/worker'

class RepositoryController extends AmznController {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
 onViewSwapComplete(e) {
  super.onViewSwapComplete(e);
  this.randomizeBgPositions()
 }

  addEventListeners() {
    // objectViewStart({})
  }
  removeEventListeners() {
    // objectViewStop()
  }

  /**
   * Own
   */
  randomizeBgPositions() {
    const list = [...document.querySelectorAll('.amznobj-repository-bg')]
    list.forEach(this.randomizeBgPosition.bind(this))
  }
  randomizeBgPosition(el, index) {
    const wW = window.innerWidth
    const wH = window.innerHeight
    const maxX = wW * .1;
    const maxY = wH * .1;
    const randX = Math.random() * maxX - maxX * .5
    const randY = Math.random() * maxY - maxY * .5
    el.style.marginTop = randY + "px"
    el.style.marginLeft = randX + "px"
  }

}

export default RepositoryController;